type SetCookieOptions = {
  name: string;
  value: string;
  days?: number; // Default: 365
  path?: string; // Default: '/'
  secure?: boolean; // Default: false
  sameSite?: 'Lax' | 'Strict' | 'None'; // Optional
};

export const setCookie = ({
  name,
  value,
  days = 365,
  path = '/',
  secure = false,
  sameSite,
}: SetCookieOptions): void => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();

  let cookie = `${name}=${value}; expires=${expires}; path=${path}`;

  if (secure) cookie += '; Secure';
  if (sameSite) cookie += `; SameSite=${sameSite}`;

  document.cookie = cookie;
};

export const getCookie = (name: string): string | undefined => {
  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`));
  return cookie?.split('=')[1];
};
